import { defineMessages } from 'react-intl';
export const layerSwitcherMessages = defineMessages({
    zoomInvisibleLayer: {
        id: 'layerSwitcher.zoomInvisibleLayer',
        defaultMessage: 'Vrstva není v dané úrovni přiblížení viditelná!',
    },
    drawBtn: {
        id: 'layerSwitcher.drawBtn',
        defaultMessage: 'Přidat prvek',
    },
    snapBtn: {
        id: 'layerSwitcher.snapBtn',
        defaultMessage: 'Přichytávat k vrstvě',
    },
    routeBtn: {
        id: 'layerSwitcher.routeBtn',
        defaultMessage: 'Zobrazit tabulku prvků vrstvy',
    },
});
//# sourceMappingURL=layerSwitcherMessages.js.map